import React, { useSyncExternalStore } from 'react';
import { subscribeMaintenance, getMaintenanceState } from 'services/maintenance';

const formatTime = (value) => {
    if (!value) return null;
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
};

/**
 * 큐베이스 점검(쓰기 동결) 안내 띠 — 점검 중에만 화면 상단에 표시된다.
 * 해제는 services/maintenance 의 상태 폴링이 판단한다.
 */
const MaintenanceBanner = () => {
    const m = useSyncExternalStore(subscribeMaintenance, getMaintenanceState);
    if (!m.active) return null;

    let text;
    if (m.unreachable) {
        text = '큐베이스 DB 전환 중 — 잠시 후 다시 연결됩니다. 작업 내용은 그대로 유지됩니다.';
    } else {
        const details = [m.message, formatTime(m.expiresAt) && `자동 해제 ${formatTime(m.expiresAt)}`]
            .filter(Boolean)
            .join(', ');
        text = `큐베이스 점검 중 — 조회만 가능합니다${details ? ` (${details})` : ''}`;
    }

    // 상단 메뉴를 덮지 않도록 화면 위 가운데에 떠 있는 알약 형태 (클릭은 아래로 통과)
    return (
        <div
            role="status"
            aria-live="polite"
            className="fixed top-1 left-1/2 -translate-x-1/2 z-[10000] max-w-[90vw] px-4 py-1.5 rounded-full shadow-md pointer-events-none text-center text-sm font-medium bg-amber-100 text-amber-900 border border-amber-300 dark:bg-amber-900 dark:text-amber-100 dark:border-amber-700"
        >
            {text}
        </div>
    );
};

export default MaintenanceBanner;
